// extracted by css-extract-rspack-plugin
export default {"kibScope":"kibScope-MbeOG8","hideArrow":"hideArrow-FKm6WN","customDropdown":"customDropdown-QOlX72"};